'use client';

import { OutlinedInput, type OutlinedInputProps } from '@mui/material';

export const CALCULATOR_INPUT_HEIGHT_PX = 40;

export type CalculatorOutlinedInputGap = 'uniform' | 'mdUp';

export type CalculatorOutlinedInputProps = Omit<OutlinedInputProps, 'sx'> & {
  hasError?: boolean;
  gap?: CalculatorOutlinedInputGap;
  sx?: OutlinedInputProps['sx'];
};

export function CalculatorOutlinedInput({
  gap = 'uniform',
  hasError = false,
  sx,
  ...rest
}: CalculatorOutlinedInputProps) {
  const gapSx = gap === 'mdUp' ? { gap: { md: '0.5rem' } } : { gap: '.5rem' };

  const outlineSx = hasError
    ? {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'reds.main',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'blues.light',
        },
        '&:hover:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
          borderColor: 'reds.main',
        },
      }
    : {
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'blues.light',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'blues.light',
        },
      };

  return (
    <OutlinedInput
      {...rest}
      sx={[
        {
          alignItems: 'center',
          borderRadius: '0.5rem',
          boxSizing: 'border-box',
          display: 'flex',
          height: CALCULATOR_INPUT_HEIGHT_PX,
          minHeight: CALCULATOR_INPUT_HEIGHT_PX,
          ...gapSx,
          paddingX: '1rem',
          paddingY: 0,
          ...outlineSx,
        },
        ...(Array.isArray(sx) ? sx : sx != null ? [sx] : []),
      ]}
    />
  );
}
